module.exports = __webpack_public_path__ + "static/media/Wdot1.1c3bb4ae.png";